var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import { colors, shadows, gradients, outlines, } from './colors';
import { suomifiDesignTokens, } from 'suomifi-design-tokens';
import { spacing } from './spacing';
import { zindexes } from './zindexes';
import { transitions } from './transitions';
import { radius } from './radius';
var internalTokens = {
    shadows: shadows,
    gradients: gradients,
    outlines: outlines,
    zindexes: zindexes,
    transitions: transitions,
    radius: radius,
};
var importedTokens = {
    colors: colors,
    spacing: spacing,
    typography: suomifiDesignTokens.typography,
    values: suomifiDesignTokens.values,
};
export var defaultTokens = __assign({}, importedTokens, internalTokens);
export var suomifiTheme = function (props) {
    var _a = props || {}, _b = _a.colors, colors = _b === void 0 ? {} : _b, _c = _a.spacing, spacing = _c === void 0 ? {} : _c, _d = _a.typography, typography = _d === void 0 ? {} : _d, libraryTokenOverrides = __rest(_a, ["colors", "spacing", "typography"]);
    var theme = __assign({}, internalTokens, (!!libraryTokenOverrides ? libraryTokenOverrides : {}), { colors: mergeTokens({
            defaultTokens: defaultTokens.colors,
            customTokens: colors,
        }), spacing: mergeTokens({
            defaultTokens: defaultTokens.spacing,
            customTokens: spacing,
        }), typography: mergeTokens({
            defaultTokens: defaultTokens.typography,
            customTokens: typography,
        }), values: defaultTokens.values });
    return theme;
};
var mergeTokens = function (_a) {
    var defaultTokens = _a.defaultTokens, _b = _a.customTokens, customTokens = _b === void 0 ? {} : _b;
    return Object.entries(customTokens).reduce(function (retObj, _a) {
        var key = _a[0], value = _a[1];
        var _b;
        return __assign({}, retObj, (_b = {}, _b[key] = value, _b));
    }, Object.assign({}, defaultTokens));
};
export var withSuomifiTheme = function (baseStyles) { return function (_a) {
    var tokens = _a.tokens, passProps = __rest(_a, ["tokens"]);
    return baseStyles(__assign({}, passProps, { tokens: tokens, theme: suomifiTheme(tokens) }));
}; };
//# sourceMappingURL=index.js.map